import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { Modulo0Page } from './pages/Modulo0Page';
import { AccessPage } from './pages/AccessPage';
import { Modulo2Page } from './pages/Modulo2Page';
import { Modulo3Page } from './pages/Modulo3Page';
import { Modulo4Page } from './pages/Modulo4Page';
import { SignupPage } from './pages/SignupPage';
import { LoginPage } from './pages/LoginPage';
import { CalculadoraPage } from './pages/CalculadoraPage';
const PIXEL_ID = '2835854783427335';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initFacebookPixel() {
  if (window.fbq) return;
  const f = window;
  const b = document;
  const n = 'script';
  let e: any;
  const t = function (this: any) {
    // eslint-disable-next-line prefer-rest-params
    t.callMethod ? t.callMethod.apply(t, arguments) : t.queue.push(arguments);
  } as any;
  if (!f.fbq) f.fbq = t;
  t.push = t;
  t.loaded = true;
  t.version = '2.0';
  t.queue = [] as any[];
  e = b.createElement(n);
  e.async = true;
  e.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = b.getElementsByTagName(n)[0];
  s?.parentNode?.insertBefore(e, s);
  window.fbq('init', PIXEL_ID);
}
export function App() {
  const path = window.location.pathname;
  useEffect(() => {
    initFacebookPixel();
    // PageView on every page
    window.fbq('track', 'PageView');
    // ViewContent on landing page
    if (path === '/' || path === '') {
      window.fbq('track', 'ViewContent', {
        content_name: 'AI Web Closer Landing Page'
      });
    }
    // AddToCart on checkout page
    if (path === '/checkout') {
      window.fbq('track', 'AddToCart', {
        content_name: 'AI Web Closer Course',
        content_type: 'product',
        value: 47,
        currency: 'USD'
      });
    }
  }, [path]);
  if (path === '/calculadora') {
    return <CalculadoraPage data-id="element-0" />;
  }
  if (path === '/checkout') {
    return <CheckoutPage data-id="element-1" />;
  }
  if (path === '/member-signup') {
    return <SignupPage data-id="element-2" />;
  }
  if (path === '/login') {
    return <LoginPage data-id="element-3" />;
  }
  if (path === '/modulo-0') {
    return <Modulo0Page data-id="element-4" />;
  }
  if (path === '/modulo-1') {
    return <AccessPage data-id="element-5" />;
  }
  if (path === '/modulo-2') {
    return <Modulo2Page data-id="element-6" />;
  }
  if (path === '/modulo-3') {
    return <Modulo3Page data-id="element-7" />;
  }
  if (path === '/modulo-4') {
    return <Modulo4Page data-id="element-8" />;
  }
  return <LandingPage data-id="element-9" />;
}